import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RecentlyViewedItemsCarousel from '../../../global/components/RecentlyViewedItems/RecentlyViewedItemsCarousel';
import {
    hasRecentlyViewedItems,
    getRecentlyViewedItems,
} from '../../../global/components/RecentlyViewedItems/recentlyViewedItemsHelpers.es';
import styles from './RecentlyViewedItems.scss';

const RecentlyViewedItems = ({ itemId }) => {
    if (!hasRecentlyViewedItems({ itemId, minItems: 1 })) {
        return null;
    }

    return (
        <div className={styles.container}>
            <h2 className="pdp-grid-header">
                <FormattedMessage
                    id="pdp.RecentlyViewedItems.recentlyViewed"
                    defaultMessage="Recently Viewed"
                />
            </h2>
            <RecentlyViewedItemsCarousel items={getRecentlyViewedItems({ itemId })} />
        </div>
    );
};

RecentlyViewedItems.propTypes = {
    itemId: PropTypes.string.isRequired,
};

export default RecentlyViewedItems;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/RecentlyViewedItems/RecentlyViewedItems.jsx